export const OBSERVABLE_CONTEXT_BASE_PRIVATE = Symbol('observable-context-base-private');
//# sourceMappingURL=privates.js.map